/**
 * Created by mac on 2/25/20
 */

const TriPeaks = function (level, options) {
    TileGame.call(this, level, options);

    this.executedMarks = [];

    const save = this.savedGame;

    if (cleverapps.Combo.isAvailable()) {
        this.combo = new cleverapps.Combo(this, save.combo);
    }

    this.levelWithCoins = cleverapps.user.checkAvailable(cleverapps.config.availables.LEVEL_WITH_COINS);

    if (cleverapps.config.debugMode && cleverapps.flags.goldOnCardsDisabled) {
        this.levelWithCoins = false;
    }

    this.hand = new Hand(this, save.hand || level.content.hand);

    this.wildcardBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_WILDCARD);

    if (this.wildcardBooster.wildcardTutorial) {
        this.wildcardBooster.deactivateTutorial();
    }

    const diceBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_DICE);
    if (this.options.boostersBefore && this.options.boostersBefore.some((boosterBefore) => boosterBefore.booster === diceBooster)) {
        this.dice = new Dice();
    }

    this.counter.registerStage(3, this.processMarks.bind(this));
    this.counter.registerStage(25, this.spawnCombo.bind(this));
};

Game = TriPeaks;

TriPeaks.prototype = Object.create(TileGame.prototype);
TriPeaks.constructor = TriPeaks;

TriPeaks.prototype.activateBoosters = function () {
    TileGame.prototype.activateBoosters.call(this);

    if (this.outcome === GameBase.OUTCOME_UNKNOWN && !cleverapps.environment.isSceneWithPreview()) {
        if (this.hand.isEmpty() && !(this.open.getCurrentCard() instanceof Wildcard)) {
            this.wildcardBooster.startHint(true);
        }
    }
};

TriPeaks.prototype.getInfo = function () {
    const info = TileGame.prototype.getInfo.call(this);

    if (!this.stopped) {
        info.hand = this.hand.getInfo();
        info.open = this.open.getInfo();
        info.page = this.pagination.getCurrent();

        if (this.combo) {
            info.combo = this.combo.getInfo();
        }
    }

    return info;
};

TriPeaks.prototype.spawnCombo = function () {
    if (this.combo) {
        this.combo.spawn();
    }
};

TriPeaks.prototype.shiftWildcard = function (wildcard) {
    cleverapps.tutorial.trigger("shiftWildcard");
    this.open.shift(wildcard);
    this.counter.trigger();
    cleverapps.userStatus.reportUserAction();

    this.wildcardBooster.stopHint();
    this.removeHint();
};

TriPeaks.prototype.isUndoRecommended = function () {
    return this.table.listMissed().length > 0;
};

TriPeaks.prototype.shiftCard = function (options) {
    options = options || {};
    if (this.open.getCurrentCard()) {
        this.table.animateMissed();
    }

    if (!options.showUp && !options.creation) {
        options.undoRecommended = this.isUndoRecommended();
    }

    const card = this.hand.shift(this.table);
    this.open.shift(card, options.silent);

    cleverapps.tutorial.trigger("shiftCard");

    card.trigger("hideTutorial");

    if (!options.creation) {
        cleverapps.effects.fire("solitaire.card.play");
    }

    if (!options.showUp && !options.creation) {
        if (this.combo) {
            this.spawnCombo();
            options.comboLevel = this.combo.level;
            options.resetAfterPrize = this.combo.resetAfterPrize;
            this.combo.reset();
        }
        if (this.table.streakCard) {
            this.table.streakCard.reset();
        }

        this.log.push(MovesLog.MOVE_SHIFT_CARD, options);

        this.move = Card.MOVES.SHIFT;
        this.table.updateFeatures(this.move);
        this.counter.trigger();
    }
};

TriPeaks.prototype.unShiftCard = function (card) {
    this.hand.push(card);
    if (card.isOpen()) {
        card.flip();
    }
    this.move = Card.MOVES.UNSHIFT;
    this.table.updateFeatures(this.move);
    this.counter.trigger();
};

TriPeaks.prototype.getInterceptor = function (card) {
    let interceptor = undefined;
    this.table.cards.forEach((tableCard) => {
        const flagsOnCard = tableCard.findComponent(FlagsOnCard);
        if (flagsOnCard && tableCard.isOpen() && flagsOnCard.lives > 0 && flagsOnCard.flags.filter((flag) => flagsOnCard.isEqualSuit(flag, card) && !(card instanceof WeakJokerCard)).length > 0) {
            interceptor = flagsOnCard;
        }
    });

    return interceptor;
};

TriPeaks.prototype.playCard = function (card) {
    TileGame.prototype.playCard.call(this, card);

    cleverapps.eventBus.trigger("play_card", { suit: card.getSuit(), rank: card.getRank() });

    const shouldIncreaseCombo = !card.feature || [CurtainCard, DoubleCard, IncDecCard, SharkCard, WeakJokerCard, SuitCard, DoubleCard].some((CardClass) => card instanceof CardClass);

    if (this.combo && shouldIncreaseCombo) {
        this.combo.increaseLevel(card.getSuit());
        if (this.combo.isFull()) {
            this.hand.hideExtra();
        }
    } else if (!this.combo) {
        if (!this.lastEffect) {
            this.lastEffect = 0;
        }
        const lastEffect = (this.lastEffect % 4) + 1;
        cleverapps.effects.fire(`solitaire.combo.${lastEffect}`);

        this.lastEffect = lastEffect;
    }

    if (this.table.streakCard && shouldIncreaseCombo && !this.table.isEmpty()) {
        this.table.streakCard.increaseLevel(card);
    }
};

TriPeaks.prototype.getCardForHint = function (forTutorial) {
    let hint = undefined;
    const missed = this.table.listMissed();
    if (missed.length) {
        if (forTutorial !== undefined) {
            const suitableCards = forTutorial.filter && missed.filter((card) => TileGameTutorialHelper.isApplicable(card, forTutorial.filter)) || [];

            hint = suitableCards.length ? suitableCards[0] : missed[0];
        } else {
            hint = missed[Math.floor(Math.random() * missed.length)];
        }
    } else if (this.hand.top() !== undefined && !this.table.isEmpty()) {
        hint = this.hand.top();
    }

    return hint;
};

TriPeaks.prototype.addJackpot = function (f, card) {
    const targetCard = card || this.table.cardsWithPossibilityOfPlacingUnderThem().pop();
    if (!targetCard) {
        f();
        return;
    }

    const jackpotCard = TileFactory.Create({
        feature: "jackpot",
        x: targetCard.x,
        y: targetCard.y,
        rotation: targetCard.getRotation()
    });
    jackpotCard.setOwner(targetCard.owner);

    this.table.insertBeforeCard(targetCard, jackpotCard);
    this.table.trigger("insertCard", jackpotCard);

    cleverapps.dataLoader.save(DataLoader.TYPES.JACKPOT_LAST_APPEAR_TIME, Date.now());

    this.counter.setTimeout(f, 3500);
};

TriPeaks.prototype.stop = function (...args) {
    TileGame.prototype.stop.apply(this, args);

    this.hand.clear();

    if (this.combo) {
        this.combo.reset();
    }
};

TriPeaks.prototype.clearTable = function (f) {
    const cards = PseudoRandom.GET().shuffle(this.table.cards);

    let maxAnimationTime = 0;
    cards.forEach((card, index) => {
        card.marks.forEach((mark) => {
            mark.trigger("hide");
        });

        card.components.forEach((component) => {
            component.onHide();
        });

        const time = card.onGetView().animateLose(cards.length - index);
        maxAnimationTime = Math.max(time, maxAnimationTime);
    });

    cleverapps.timeouts.setTimeout(() => {
        this.table.clear();
        f();
    }, maxAnimationTime * 1000);
};

TriPeaks.prototype.needBonusByLeftMoves = function () {
    return this.outcome === GameBase.OUTCOME_VICTORY;
};

TriPeaks.prototype.animateBonus = function (f) {
    new ActionPlayer([
        this.clearTable.bind(this),

        function (f) {
            const sceneComponent = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent);
            sceneComponent.createBonusChest();

            this.hand.animateBonus(() => {
                sceneComponent.bonusChest.animationLeave(f);
            });
        }.bind(this)
    ]).play(f);
};

TriPeaks.prototype.setMoves = function (moves, options) {
    this.hand.extra.hide();
    if (Game.currentGame.wildcardBooster) {
        Game.currentGame.wildcardBooster.stopHint();
    }
    this.counter.setTimeout(() => {
        this.hand.addExtra(moves, options || {});
    }, 300);
};

TriPeaks.prototype.processMarks = function () {
    while (this.executedMarks.length > 0) {
        const mark = this.executedMarks.shift();
        mark.execute();
        if (this.counter.isActive()) {
            return;
        }
    }
};

TriPeaks.prototype.executeMark = function (mark) {
    this.executedMarks.push(mark);
};

TriPeaks.prototype.showScreen = function (f, silent) {
    cleverapps.focusManager.compound(f, [
        (f) => {
            f = cleverapps.wait(2, f);

            this.table.onResize();
            this.table.showCards(f, silent);
            this.hand.showUp(f, silent);
        },

        (f) => {
            if (!this.open.cards.length && cleverapps.environment.isGameScene() && !this.levelWithTutorial()) {
                this.shiftCard({
                    showUp: true,
                    silent
                });
            }
            this.flip(f, silent);
        },

        (f) => {
            if (JackpotCard.isAvailable() && this.level.isRegular() && Math.random() < 0.1) {
                this.addJackpot(f);
            } else {
                f();
            }
        }
    ]);
};